import _axios from '../../apiClient'

export function getCalendario(payload) {
  console.log('GetCalendario con idInstalacion: ', payload.idInstalacion);

  return _axios.post(`/api/Turnero/GetCalendario`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}